<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Kas Keluar</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA KAS KELUAR</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Cabang</b-col>
                    <b-col>{{ kasKeluar.cabang }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nominal</b-col>
                    <b-col>Rp. {{ $helper.addThousandSeparator(kasKeluar.nominal) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diajukan oleh</b-col>
                    <b-col>{{ kasKeluar.diajukanOleh }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diajukan pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(kasKeluar.diajukanPada )}} {{ $helper.changeDateFormatGetHour(kasKeluar.diajukanPada )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(kasKeluar.keterangan)">{{ kasKeluar.keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>

            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">HASIL KAS KELUAR</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="kasKeluar.status != null" >{{ kasKeluar.status }}</b-col>
                </b-row> 
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses pada</b-col>
                    <b-col v-if="kasKeluar.diprosesPada != null">{{ $helper.changeDateFormat(kasKeluar.diprosesPada )}} {{ $helper.changeDateFormatGetHour(kasKeluar.diprosesPada )}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses oleh</b-col>
                    <b-col v-if="kasKeluar.diprosesOleh != null">{{ kasKeluar.diprosesOleh }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(kasKeluar.keteranganProses)">{{ kasKeluar.keteranganProses }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            
            <b-form v-if="kasKeluar.status == 'PENDING'" @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">PERSETUJUAN KAS KELUAR</h6>
                    <b-form-group label="Status">
                        <b-row>
                            <b-col md="4">
                                <b-form-group>
                                    <label class="radio-label">
                                        <b-form-radio v-model="input.isApproved" value="true">Setujui</b-form-radio>
                                    </label>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group>
                                    <label class="radio-label">
                                        <b-form-radio v-model="input.isApproved" value="false">Tolak</b-form-radio>
                                    </label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="4" md="6">
                                <b-form-group label="Keterangan">
                                    <b-form-textarea v-model="input.keteranganApproval" name="keterangan"></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="kasKeluarSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
            <ModalConfirm id="modal-confirm" title="Confirm Kas Keluar" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengganti status Kas Keluar ini?" @submit="onSubmit" />
        </b-card>
    </div>
</template>

<script>
import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-kasKeluar',
    data(){
        return{
            id: null,
            noFaktur: null,
            isSubmitting: false,
            initStatus: 0,
            kasKeluar: {},
            dataGadai: {},
            input: {
                keteranganApproval: "",
                isApproved: 'true'
            }
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSinglekasKeluar = this.$axios.get(`approval-kas-keluar/${this.id}`).then(response => {
                this.kasKeluar = response.data
            })

            Promise.all([getSinglekasKeluar]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            if (this.input.isApproved == 'true') {
                if (this.input.keteranganApproval != "") payload.append('keterangan', this.input.keteranganApproval)
            }
            else {
                payload.append('keterangan', this.input.keteranganApproval)
            }

            //----------------- Append Data Kas Keluar -----------------
            
            payload.append('id', this.id)
            payload.append('approve', this.input.isApproved)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post('approval-kas-keluar/process', payload).then(response => {
                this.$bvModal.hide("modal-confirm")
                this.$helper.setFlash("Status Kas Keluar berhasil diubah!")

                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
             if (this.input.isApproved == 'false' && this.keteranganApproval == ""){
                this.$helper.toastErr(this, "Mohon isi keterangan!")
            }
            else {
                this.$bvModal.show("modal-confirm")
            }
        }
    },

    created(){
        this.init()
    }
}
</script>
